var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-1" },
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "partner-name",
                          label: _vm.$t("Nome do parceiro"),
                          placeholder: _vm.$t("Nome"),
                        },
                        model: {
                          value: _vm.filters.partnerName,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "partnerName", $$v)
                          },
                          expression: "filters.partnerName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "partnership-cnpj",
                          label: _vm.$t("CNPJ"),
                          placeholder: _vm.$t("CNPJ"),
                        },
                        model: {
                          value: _vm.filters.cnpj,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "cnpj", $$v)
                          },
                          expression: "filters.cnpj",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "partnership-partner-type",
                          type: "vue-select",
                          label: _vm.$t("Tipo de parceiro"),
                          placeholder: _vm.$t("Selecione o tipo"),
                          options: _vm.partnerTypeOptions,
                        },
                        model: {
                          value: _vm.filters.partnerType,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "partnerType", $$v)
                          },
                          expression: "filters.partnerType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "partnership-active",
                          type: "vue-select",
                          label: _vm.$t("Status"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.statusOptions,
                        },
                        model: {
                          value: _vm.filters.active,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "active", $$v)
                          },
                          expression: "filters.active",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "partnerships-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("PARTNERSHIP.NAME"),
                "female",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.partnerships,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(cnpj)",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("cpfCnpj")(row.item.cnpj))),
                    ]),
                  ]
                },
              },
              {
                key: "cell(estimatedParticipants)",
                fn: function (row) {
                  return [
                    _c("span", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.item.estimatedParticipants)),
                    ]),
                  ]
                },
              },
              {
                key: "cell(priceTableName)",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(row.item.priceTableName || "-")),
                    ]),
                  ]
                },
              },
              {
                key: "cell(partnershipUrl)",
                fn: function (row) {
                  return [
                    row.item.partnershipUrl
                      ? _c(
                          "span",
                          {
                            staticClass: "text-truncate",
                            staticStyle: {
                              "max-width": "180px",
                              display: "inline-block",
                            },
                            attrs: { title: row.item.partnershipUrl },
                          },
                          [_vm._v(" " + _vm._s(row.item.partnershipUrl) + " ")]
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
              {
                key: "cell(active)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.active },
                    }),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "is-active": row.item.active,
                        "show-update": _vm.$can("Update", "Partnership"),
                        "show-delete": _vm.$can("Delete", "Partnership"),
                        "show-activate": _vm.$can("Activate", "Partnership"),
                        "show-deactivate": _vm.$can(
                          "Deactivate",
                          "Partnership"
                        ),
                        "show-read-only": true,
                      },
                      on: {
                        update: function ($event) {
                          return _vm.showUpdatePartnershipSidebar(row)
                        },
                        delete: function ($event) {
                          return _vm.deletePartnership(row)
                        },
                        activate: function ($event) {
                          return _vm.activateDeactivatePartnership(row)
                        },
                        deactivate: function ($event) {
                          return _vm.activateDeactivatePartnership(row)
                        },
                        "read-only": function ($event) {
                          return _vm.showUpdatePartnershipSidebar(row, true)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "partnership-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("partnership-sidebar", {
        ref: "partnership_sidebar",
        on: { save: _vm.getData },
      }),
      _vm.$can("Create", "Partnership")
        ? _c("fab", {
            attrs: { "main-tooltip": _vm.$t("Adicionar Parceria") },
            on: { click: _vm.showCreatePartnershipSidebar },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }